/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import { useScreenSize } from "../../../_context/ScreenSizeProvider";
import TextSection from "./TextSection";
import ImageSection from "./ImageSection"; // Directly import components

// Sections array with id, name, and component
const sections = [
  { id: "text-section", component: TextSection },
  { id: "image-section", component: ImageSection },
];

const MainSection = () => {
  const { width } = useScreenSize();

  const widthUpdate = width * 0.4;

  return (
    <Box
      display="flex"
      flexDirection={{ lg: "row", md: "column", sm: "column", xs: "column" }}
      justifyContent="space-between"
      alignItems="center"
      sx={{ width: "100%" }}
    >
      {sections.map(({ id, component: Section }, index) => (
        <Box
          key={id}
          flex="1"
          color="white"
          textAlign="center"
          minHeight={`${widthUpdate}px`}
          width={"100%"}
          justifyContent="center"
          alignItems="center"
          sx={{
            display:
              index === 0
                ? "flex"
                : { lg: "flex", md: "none", sm: "none", xs: "none" },
          }}
        >
          <Section
            {...(id !== "text-section"
              ? {
                  largeCircleSize: widthUpdate,
                  smallCircleSize: 20,
                  color: "#FF5733",
                }
              : {})}
          />
        </Box>
      ))}
    </Box>
  );
};

export default MainSection;
